import { TFunction } from "i18n";
import { IDropdownCheckboxValueItemConfig } from "../../../../Molecules/DropdownCheckbox/DropdownCheckboxValue";

export enum IContractStatus {
  current = "current",
  renewing = "renewing",
  expired = "expired",
}

export function getContractStatus(
  t: TFunction
): IDropdownCheckboxValueItemConfig[] {
  return Object.values(IContractStatus).map((status) => ({
    value: status,
    label: t(`common:search.filters.contractStatus.${status}`),
    selectedLabel: "",
  }));
}
